import { Typography, TypographyProps } from '@mui/material'

export const PageHeader = (headerProps: TypographyProps) => <Typography className='page-header' {...headerProps} />

export default PageHeader
